export const QA_ACTIONS = {
  ADVANCED_LOGIC: 'ADVANCED_LOGIC',
  NAVIGATION_LOGIC: 'NAVIGATION_LOGIC',
  DISPLAY_LOGIC: 'DISPLAY_LOGIC',
  EXCLUSIVE: 'EXCLUSIVE',
  UPLOAD_MEDIA: 'UPLOAD_MEDIA',
  REORDER_UP: 'REORDER_UP',
  REORDER_DOWN: 'REORDER_DOWN',
  UNCONDITIONAL_HIDE: 'UNCONDITIONAL_HIDE',
  REMOVE_QUESTION: 'REMOVE_QUESTION',
  REMOVE_NODE: 'REMOVE_NODE',
  REMOVE_ATTRIBUTE: 'REMOVE_ATTRIBUTE',
  REMOVE_ANSWER: 'REMOVE_ANSWER',
  AI_ACTIONS: 'AI_ACTIONS',
  FAVORITE: 'FAVORITE',
  SCREENING_ALLOWED: 'SCREENING_ALLOWED',
  GENERATE_MAXDIFF_DESIGN: 'GENERATE_MAXDIFF_DESIGN',
  DOWNLOAD_MAXDIFF_DESIGN: 'DOWNLOAD_MAXDIFF_DESIGN',
};

export const QA_SUPPORTED_ACTIONS = {
  QUESTION_PROMPT: [
    QA_ACTIONS.NAVIGATION_LOGIC,
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.UPLOAD_MEDIA,
    QA_ACTIONS.FAVORITE,
    QA_ACTIONS.AI_ACTIONS,
    QA_ACTIONS.REMOVE_QUESTION,
  ],
  ANSWER: [
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.EXCLUSIVE,
    QA_ACTIONS.UPLOAD_MEDIA,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.AI_ACTIONS,
    QA_ACTIONS.UNCONDITIONAL_HIDE,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  MATRIX_ROW: [
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.UPLOAD_MEDIA,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.UNCONDITIONAL_HIDE,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  MATRIX_COLUMN: [
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.EXCLUSIVE,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.UNCONDITIONAL_HIDE,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  MATRIX_OPEN_ENDED_ROW: [
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.UPLOAD_MEDIA,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.UNCONDITIONAL_HIDE,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  MATRIX_OPEN_ENDED_COLUMN: [
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.UNCONDITIONAL_HIDE,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  AB_TEST_ROW: [QA_ACTIONS.DISPLAY_LOGIC],
  AB_TEST_COLUMN: [QA_ACTIONS.DISPLAY_LOGIC, QA_ACTIONS.EXCLUSIVE],
  GROUP: [
    QA_ACTIONS.NAVIGATION_LOGIC,
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.REMOVE_NODE,
  ],
  CONJOINT_GROUP: [
    QA_ACTIONS.GENERATE_MAXDIFF_DESIGN,
    QA_ACTIONS.DOWNLOAD_MAXDIFF_DESIGN,
    QA_ACTIONS.NAVIGATION_LOGIC,
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.REMOVE_NODE,
  ],
  MAXDIFF_GROUP: [
    QA_ACTIONS.GENERATE_MAXDIFF_DESIGN,
    QA_ACTIONS.DOWNLOAD_MAXDIFF_DESIGN,
    QA_ACTIONS.NAVIGATION_LOGIC,
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.REMOVE_NODE,
  ],
  CONJOINT_ATTRIBUTE: [
    QA_ACTIONS.UPLOAD_MEDIA,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.REMOVE_ATTRIBUTE,
  ],
  CONJOINT_LEVEL: [
    QA_ACTIONS.UPLOAD_MEDIA,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.REMOVE_NODE,
  ],
  MAXDIFF_ATTRIBUTE: [QA_ACTIONS.UPLOAD_MEDIA],
  SCREENING_ANSWER: [
    QA_ACTIONS.SCREENING_ALLOWED,
    QA_ACTIONS.DISPLAY_LOGIC,
    QA_ACTIONS.UPLOAD_MEDIA,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.AI_ACTIONS,
    QA_ACTIONS.UNCONDITIONAL_HIDE,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  SLIDER_TICK: [
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.AI_ACTIONS,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  VAN_WESTENDORP_ANSWER: [QA_ACTIONS.AI_ACTIONS],
  CONVERSATIONAL_OBJECTIVE: [QA_ACTIONS.AI_ACTIONS],
  CONVERSATIONAL_GOAL: [
    QA_ACTIONS.AI_ACTIONS,
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.REMOVE_ANSWER,
  ],
  LOOP_MERGE_CONCEPT: [
    QA_ACTIONS.REORDER_UP,
    QA_ACTIONS.REORDER_DOWN,
    QA_ACTIONS.REMOVE_NODE,
  ],
  LOOP_MERGE_ATTRIBUTE: [QA_ACTIONS.REMOVE_NODE],
};

// Indicator layout: fixed item box + flex gap between items.
export const INDICATOR_ITEM_SIZE = 24;
export const INDICATOR_GAP = 12;
export const INDICATORS_TO_DROPDOWN_GAP = 10;
export const ACTIONS_FROM_INPUT_GAP = 12;
export const DROPDOWN_TRIGGER_SIZE = 16;

/** @deprecated Use getIndicatorAreaWidth instead. */
export const INDICATOR_SLOT_WIDTH = INDICATOR_ITEM_SIZE;

export const getIndicatorAreaWidth = (slotCount = 0) => {
  if (!slotCount || slotCount <= 0) {
    return 0;
  }

  return slotCount * INDICATOR_ITEM_SIZE + (slotCount - 1) * INDICATOR_GAP;
};

export const getActionsAreaMinWidth = (maxIndicatorSlots = 0) => {
  const indicatorWidth = getIndicatorAreaWidth(maxIndicatorSlots);

  if (indicatorWidth <= 0) {
    return DROPDOWN_TRIGGER_SIZE;
  }

  return indicatorWidth + INDICATORS_TO_DROPDOWN_GAP + DROPDOWN_TRIGGER_SIZE;
};
